import { createRouter } from '@tanstack/react-router';
// Сгенерированное routeTree создаётся @tanstack/router-plugin при build/dev.
// В CI и при first-install файл отсутствует — этого не избежать без `pnpm install`.
// TODO(S1): после pnpm install — vite plugin сгенерирует src/routeTree.gen.ts.
import { routeTree } from '~/routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 30_000,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  /**
   * chat-panel-geometry F-7 [Г14] — канал «маршрут → чат-панель».
   *
   * Страница объявляет, уже какой ширины `.main` ей нельзя становиться —
   * вместе со своими полями и полосой прокрутки. Панель читает объявление
   * через `useMatches()` и не уступает полотну меньше этого числа. Поля
   * необязательное: не объявила — действует `PAGE_MIN_DEFAULT`.
   */
  interface StaticDataRouteOption {
    minMainWidth?: number;
  }
}
